import { styled } from '@linaria/react';
import { m } from 'framer-motion';
import { COLORS, typographyStyles, Pill as _Pill } from '@livecommerce/design-system';

const { getBodyText, getMediumHeadline } = typographyStyles;

export const IconWrapper = styled.div`
  display: flex;
  border-radius: 6px;
  height: 100%;
  align-items: center;
  justify-content: center;
  circle,
  ellipse,
  path {
    fill: ${COLORS.orange_500};
    transition: fill 0.2s ease-in-out;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  ${getMediumHeadline(18)};
  line-height: 27px;
  color: ${COLORS.white};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Pill = styled(_Pill)`
  font-size: 10px;
  border-radius: 10px;
  padding: 0px 8px;
  line-height: 15px;
`;

export const Subtitle = styled.div`
  ${getBodyText(12, 400)};
  line-height: 18px;
  min-height: 18px;
  color: ${COLORS.light_700};

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Button = styled(m.button)`
  position: relative;
  display: grid;
  grid-template-columns: 44px 1fr ${(props) => props['aria-pressed'] || props['aria-controls'] ? '44px' : '0'};
  grid-template-rows: 1fr;
  align-items: center;
  column-gap: 16px;
  width: 100%;

  text-align: left;
  text-decoration: none;

  margin: 0;
  padding: 8px 12px 8px 8px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background-color: ${COLORS.dark_1000};
  color: ${(props) => props.color};

  &[aria-controls] {
    ${IconWrapper},
    ${TextWrapper},
    ${StyledIcon} {
      transition: transform 0.25s ease-in-out;
      transform: translateX(-8px);
    }
    &:hover {
      background-color: ${COLORS.dark_600};
    }
    &:focus-visible,
    &:hover,
    &[aria-pressed='true'],
    &:disabled {
      ${IconWrapper},
      ${TextWrapper},
      ${StyledIcon} {
        transform: translateX(0);
      }
    }
  }

  transition: background-color 0.2s ease-in-out;

  &:focus-visible,
  &:hover {
    &[aria-pressed='false']:not([disabled]):not([aria-controls]) {
      background-color: ${COLORS.dark_400};

      ${Title} {
        color: ${COLORS.light_000};
      }

      ${Subtitle} {
        color: ${COLORS.light_100};
      }
      circle,
      ellipse,
      path {
        fill: ${COLORS.light_000};
      }
    }
  }

  &[aria-pressed='true']:not([disabled]):not([aria-controls]) {
    background-color: ${COLORS.light_100};

    ${Title} {
      color: ${COLORS.dark_700};
    }

    ${Subtitle} {
      color: ${COLORS.dark_500};
    }
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:disabled {
    ${IconWrapper} {
      background-color: ${COLORS.dark_700};
    }

    cursor: auto;
    opacity: 0.2;
  }
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChevronWrapper = styled(m.div)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
